import { fontSizes, letterSpacing, space } from "theme/themeConfig";
import { fontVariants } from "../fontVariants";
import { linkStates } from "./link";
import { colours } from "@shared/ui.design-system";

const ProductCardLabelBaseStyles = {
  ...fontVariants.capsM2,
  position: "absolute",
  top: 0,
  marginTop: 0,
  textTransform: "uppercase",
  background: colours.secondary.warm,
  color: colours.primary.dark,
  p: `${space["-2"]} ${space["-1"]}`,
  display: "inline-block"
};

const ABTestProductCardBaseStyles = {
  ...fontVariants.capsM2,
  position: "absolute",
  bottom: 0,
  textTransform: "uppercase",
  background: colours.secondary.warm,
  color: colours.primary.dark,
  p: `${space["-2"]} ${space["-1"]}`,
  display: "inline-block"
};

const blockQ = {
  position: "relative",
  marginTop: 3,
  marginBottom: 3,
  "&:focus": {
    boxShadow: "0",
    background: `${colours.secondary.warm}`
  },
  a: {
    ...linkStates
  }
};

export const Text = {
  baseStyle: {
    mt: 1
  },
  variants: {
    ...fontVariants,
    availabilityWhite: ProductCardLabelBaseStyles,
    availabilityWhiteB: ABTestProductCardBaseStyles,
    availabilityPink: {
      ...ProductCardLabelBaseStyles,
      background: colours.accent.soft,
      color: colours.primary.dark
    },
    availabilityPinkB: {
      ...ABTestProductCardBaseStyles,
      background: colours.accent.soft,
      color: colours.primary.dark
    },
    availabilityGrey: {
      ...ProductCardLabelBaseStyles,
      background: colours.secondary.warm,
      color: colours.primary.dark
    },
    availabilityGreyB: {
      ...ABTestProductCardBaseStyles,
      background: colours.secondary.warm,
      color: colours.primary.dark
    },
    pieDay: {
      ...ProductCardLabelBaseStyles,
      background: colours.accent.light,
      color: colours.accent.strong,
      fontWeight: 500,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "90px",
      padding: `0rem ${space["-1"]}`
    },
    pieDayB: {
      ...ABTestProductCardBaseStyles,
      background: colours.accent.light,
      color: colours.accent.strong,
      fontWeight: 500,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "90px",
      padding: `0rem ${space["-1"]}`
    },
    pieDayIcon: {
      ...ProductCardLabelBaseStyles,
      background: colours.accent.light,
      color: colours.accent.strong,
      width: "24px",
      height: "24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    pieDayIconB: {
      ...ABTestProductCardBaseStyles,
      background: colours.accent.light,
      color: colours.accent.strong,
      width: "24px",
      height: "24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    treasureHunt: {
      ...ProductCardLabelBaseStyles,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: colours.accent.light,
      color: colours.primary.dark,
      borderLeft: `5px solid ${colours.accent.strong}`,
      paddingRight: "10px",
      width: space[10],
      height: space[2]
    },
    treasureHuntB: {
      ...ABTestProductCardBaseStyles,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: colours.accent.light,
      color: colours.primary.dark,
      borderLeft: `5px solid ${colours.accent.strong}`,
      paddingRight: "10px",
      width: space[10],
      height: space[2]
    },
    blockquote2: {
      ...fontVariants.demi2,
      ...blockQ
    },
    blockquote3: {
      ...fontVariants.demi3,
      ...blockQ
    },

    searchResultsTitle: {
      ...fontVariants.capsM2,
      color: colours.primary.dark,
      marginBottom: space["1"],
      letterSpacing: letterSpacing.normal,
      fontSize: fontSizes[0]
    },

    cartText: {
      ...fontVariants.acuminLight,
      color: "black",
      fontWeight: "bold",
      fontSize: "20px"
    },
    demiText: {
      ...fontVariants.acuminSemiBold,
      color: "black",
      fontSize: "20px"
    },
    demiTextTitle: {
      ...fontVariants.acuminRegular,
      color: "black",
      lineHeight: "30px",
      fontSize: "20px"
    }
  }
};
